import { h } from "preact";
import { MdOutlineRemoveRedEye } from "react-icons/md";

const CredentialImage = ({ image, pdf }) => {
  if (!image) return null;

  return (
    <article class="w-full rounded-lg bg-[#fff] my-3 lg:mt-0">
      <div class="flex flex-col items-center">
        <div class="relative w-[95%] h-auto my-[20px] group/degree">
          <img
            class="w-full h-full object-cover rounded pointer-events-none"
            src={image.id}
            alt={image.name}
          />
          <div class="hidden absolute inset-0 bg-black/20 bg-opacity-60 items-center justify-center group-hover/degree:flex">
            <a
              href={pdf?.id}
              download="diploma.pdf"
              class="w-40 h-[37px] flex items-center justify-center text-[#fff] font-light rounded-md border border-[#890f20] shadow-[0_2px_4px_0_rgba(0,0,0,0.5)] border-solid bg-[#890f20]"
            >
              <MdOutlineRemoveRedEye class="w-5 h-5 mr-2" />
              Ver diploma
            </a>
          </div>
        </div>
      </div>
    </article>
  );
};

export default CredentialImage;
